module.exports = __webpack_public_path__ + "static/media/phone.d90b66e1.svg";